import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../utils/intercepter/axiosConfig.js";

const CreerVente = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const TOAST_POSITION = "top-right";

  const [notFoundIndex, setNotFoundIndex] = useState(null); // index de l'acheteur non trouvé
  const [loading, setLoading] = useState(false);

  const [isSubmitting, setIsSubmiting] = useState(false);

  const [nombreAcheteurs, setNombreAcheteurs] = useState(1);
  const [acheteurs, setAcheteurs] = useState([
    {
      nni: "",
      nom: "",
      dateNaissance: "",
      civilitée: "",
      ville_nais_new_pro: "",
      isNewAcheteur: false,
    },
  ]);

  // Champs globaux du formulaire
  const [montant, setMontant] = useState("");
  const [id_notaire, setIdNotaire] = useState("");
  const [id_user, setIdUser] = useState("");
  const [num_tf, setNumTF] = useState("");
  const [nni_tf,setNniTF] = useState('');
  const [id_cercle,setIdCercle] = useState('');

  // Options civilité
  const options = [
    { value: "1", label: "Homme" },
    { value: "2", label: "Femme" },
  ];

  // Base locale simulée
  const database = [
    {
      nni: "123456789",
      nom: "Mohamed Ali",
      dateNaissance: "2000-12-12",
      civilitée: "1",
      ville_nais_new_pro: "Nouakchott",
    },
    {
      nni: "987654321",
      nom: "Fatima Zahra",
      dateNaissance: "1999-02-12",
      civilitée: "2",
      ville_nais_new_pro: "Néma",
    },
    {
      nni: "0000000000",
      nom: "Ahmed Ould Brahim",
      dateNaissance: "2008-10-12",
      civilitée: "1",
      ville_nais_new_pro: "Timbedra",
    },
  ];

  useEffect(() => {
    if (state?.idNotaire && state?.numTf && state?.idUser && state?.nni && state?.idCercle) {
      setIdNotaire(state.idNotaire);
      setIdUser(state.idUser);
      setNumTF(state.numTf);
      setNniTF(state.nni);
      setIdCercle(state.idCercle);
    }
  }, [state]);



  // Gérer le changement du nombre d'acheteurs
  const handleNombreChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    if (value > 10) value = 10; // max 10 acheteurs

    setNombreAcheteurs(value);
    setAcheteurs((prev) => {
      const newArray = [...prev];
      if (value > prev.length) {
        for (let i = prev.length; i < value; i++) {
          newArray.push({
            nni: "",
            nom: "",
            dateNaissance: "",
            civilitée: "",
            ville_nais_new_pro: "",
            isNewAcheteur: false,
          });
        }
      } else {
        newArray.length = value;
      }
      return newArray;
    });
  };

  // Mise à jour des données d'un acheteur (champ)
  const handleAcheteurChange = (index, field, value) => {
    setAcheteurs((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };

      // Si on modifie le NNI, on considère que l'acheteur doit être recherché ou manuellement saisi
      if (field === "nni") {
        copy[index].isNewAcheteur = false; // Reset saisie manuelle
        if (notFoundIndex === index) setNotFoundIndex(null);
      }

      return copy;
    });
  };

  // Recherche dans base locale
  const fetchAcheteurInfo = (index) => {
    setLoading(true);
    const nni = acheteurs[index].nni.trim();

    if (!nni) {
      setLoading(false);
      return;
    }

    const result = database.find((acheteur) => acheteur.nni === nni);

    if (result) {
      // Remplit les champs à partir de la base locale
      setAcheteurs((prev) => {
        const copy = [...prev];
        copy[index] = {
          ...copy[index],
          nom: result.nom,
          dateNaissance: result.dateNaissance,
          civilitée: result.civilitée,
          ville_nais_new_pro: result.ville_nais_new_pro,
          isNewAcheteur: false,
        };
        return copy;
      });
      setNotFoundIndex(null);
    } else {
      // Acheteur non trouvé => affichage formulaire de saisie manuelle
      setAcheteurs((prev) => {
        const copy = [...prev];
        copy[index].isNewAcheteur = true;
        return copy;
      });
      setNotFoundIndex(index);
    }
    setLoading(false);
  };

  // Pour saisir manuellement un acheteur quand non trouvé
  const handleManualInputChange = (index, field, value) => {
    setAcheteurs((prev) => {
      const copy = [...prev];
      copy[index][field] = value;
      return copy;
    });
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault(); // empêche la soumission par défaut
    setIsSubmiting(true);

    // Valider que chaque acheteur a au moins NNI, nom et dateNaissance
    for (let i = 0; i < acheteurs.length; i++) {
      const a = acheteurs[i];
      if (!a.nni.trim() || !a.nom.trim() || !a.dateNaissance) {
        // toast.error(`Veuillez compléter les informations de l'acheteur ${i + 1}`, {
        //   position: TOAST_POSITION,
        // });
        return;
      }
    }

    // Concaténer les valeurs pour tous les acheteurs
    // const premiereAnnee = premiereDate.includes("-") ? premiereDate.split("-")[0] : "";
    const nomsConcaténés = acheteurs.map((a) => a.nom).join(" | ");
    const nnisConcaténés = acheteurs.map((a) => a.nni).join(" | ");
    const villesConcaténés = acheteurs.map((a) => a.ville_nais_new_pro).join(" | ");
    const premiereDate = acheteurs[0]?.dateNaissance || "";

    // Inverser le format de la date (YYYY-MM-DD => DD-MM-YYYY)
    const premiereDateOriginale = premiereDate; // "2008-10-12"
    const annee_nais_new_pro = premiereDateOriginale
      ? premiereDateOriginale.split("-").reverse().join("-")
      : "";

    // console.log("id_notaire : ", id_notaire) 
    // console.log("id_user : ", id_user) 
    // console.log("nni_acheteur : ", nnisConcaténés) 
    // console.log("nom_acheteur : ", nomsConcaténés) 
    // console.log("num_tf : ", num_tf)
    // console.log("montant : ", montant) 
    // console.log("ville_nais_new_pro : ", villesConcaténés) 
    // console.log("annee_nais_new_pro : ", annee_nais_new_pro)


    // console.log("id cercle (useEffect 2):", id_cercle);
    // console.log("nni TF (useEffect 2):", nni_tf);
    

    try {
      const response = await api.post("/auth/initier_vente", {
        id_notaire: id_notaire,
        id_user: id_user,
        num_tf: num_tf,
        nni_acheteur: nnisConcaténés,
        nom_acheteur: nomsConcaténés,
        montant: montant,
        ville_nais_new_pro: villesConcaténés,
        annee_nais_new_pro: annee_nais_new_pro,
        civilie: "1",
        nni: nni_tf,
        id_cercle: id_cercle
      });

      if (response.data.success && response.data.id_mutation) {
        navigate(`/vente/details/${response.data.id_mutation}`);
      } else {
        // toast.error(response.data.message || "Erreur lors de la création de la vente", {
        //   position: TOAST_POSITION,
        // });
      }
    } catch (error) {
      // toast.error("Erreur de connexion au serveur", { position: TOAST_POSITION });
    }finally{
      setIsSubmiting(false);
    }
  };

  return (
    <div className="container mt-3">
      <h2 className="mb-4 text-center">Création de la Vente</h2>
      <hr />

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="form-label">Nombre d'Acheteurs :</label>
          <input
            type="number"
            className="form-control"
            value={nombreAcheteurs}
            onChange={handleNombreChange}
            min="1"
            max="10"
            placeholder="Entrez le nombre d'acheteurs"
          />
        </div>

        {/* Formulaires dynamiques pour chaque acheteur */}
        <div className="row g-4">
          {acheteurs.map((acheteur, index) => (
            <div key={index} className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Acheteur {index + 1}</h5>

                  {/* NNI + bouton recherche */}
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Saisir le NNI"
                      value={acheteur.nni}
                      onChange={(e) => handleAcheteurChange(index, "nni", e.target.value)}
                    />
                    <button
                      className="btn btn-success btn-sm"
                      type="button"
                      onClick={() => fetchAcheteurInfo(index)}
                      disabled={loading}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        "Rechercher"
                      )}
                    </button>
                  </div>

                  {/* Si acheteur trouvé : champs remplis automatiquement, non modifiables */}
                  {!acheteur.isNewAcheteur && acheteur.nom && (
                    <>
                      <div className="mb-2">
                        <label className="form-label">Nom :</label>
                        <input type="text" className="form-control" value={acheteur.nom} readOnly />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Date de naissance :</label>
                        <input type="date" className="form-control" value={acheteur.dateNaissance} readOnly />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Civilité :</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            acheteur.civilitée === "1" ? "Homme" : acheteur.civilitée === "2" ? "Femme" : ""
                          }
                          readOnly
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Ville de naissance :</label>
                        <input
                          type="text"
                          className="form-control"
                          value={acheteur.ville_nais_new_pro}
                          readOnly
                        />
                      </div>
                    </>
                  )}

                  {/* Si acheteur non trouvé : saisie manuelle */}
                  {acheteur.isNewAcheteur && (
                    <>
                      <div className="mb-2">
                        <label className="form-label">Nom :</label>
                        <input
                          type="text"
                          className="form-control"
                          value={acheteur.nom}
                          onChange={(e) => handleManualInputChange(index, "nom", e.target.value)}
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Date de naissance :</label>
                        <input
                          type="date"
                          className="form-control"
                          value={acheteur.dateNaissance}
                          onChange={(e) => handleManualInputChange(index, "dateNaissance", e.target.value)}
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Civilité :</label>
                        <select
                          className="form-select"
                          value={acheteur.civilitée}
                          onChange={(e) => handleManualInputChange(index, "civilitée", e.target.value)}
                        >
                          <option value="">Sélectionnez la civilité</option>
                          {options.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Ville de naissance :</label>
                        <input
                          type="text"
                          className="form-control"
                          value={acheteur.ville_nais_new_pro}
                          onChange={(e) => handleManualInputChange(index, "ville_nais_new_pro", e.target.value)}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Champs globaux */}
        <div className="mb-3">
          <label className="form-label">Montant de la Vente :</label>
          <input
            type="number"
            className="form-control"
            value={montant}
            onChange={(e) => setMontant(e.target.value)}
            placeholder="Montant en UM"
          />
        </div>

        {/* Bouton soumission */}
        <button type="submit" className="btn btn-success btn-sm w-100" disabled={isSubmitting}>
          {isSubmitting ? 'En cours' : 'Initier une vente'}
        </button>
      </form>

      {/* <ToastContainer /> */}
    </div>
  );
};

export default CreerVente;
